import { Component } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { ToolComponent } from "@igo2/common/tool";
import { ShareMapUrlComponent } from "@igo2/context";
import { IgoMap } from "@igo2/geo";
import { MapState } from "@igo2/integration";
import { TranslateModule } from '@ngx-translate/core';

@ToolComponent({
  name: 'sigt-share-map',
  title: 'igo.integration.tools.shareMap',
  icon: 'share'
})
@Component({
    selector: 'sigt-share-map-tool',
    templateUrl: './sigt-share-map-tool.component.html',
    styleUrls: ['./sigt-share-map-tool.component.scss'],
    imports: [
        MatTabsModule,
        TranslateModule,
        ShareMapUrlComponent
    ]
})
export class SigtShareMapTool {
  get map(): IgoMap {
    return this.mapState.map;
  }

  constructor(
    private mapState: MapState
  ) { }
}
